import React from 'react';
import { PiXLight } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Alert } from 'src/modules/shared/components/atoms/alert';
import { motion, AnimatePresence } from 'framer-motion';
import { Text } from 'src/modules/shared/components/atoms/text';

interface MediaProcessingDisplayProps {
  content: string | null;
  type: 'textRepresentation' | 'summary' | null;
  onClose: () => void;
  className?: string;
}

export const MediaProcessingDisplay: React.FC<MediaProcessingDisplayProps> = ({
  content,
  type,
  onClose,
  className = '',
}) => {
  if (!content || !type) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        className={`overflow-hidden mb-2 ${className}`}
      >
        <Alert
          appearance="soft"
          message={
            <div className="flex w-full gap-2 justify-between">
              <div className="flex flex-1 items-center">
                <Text size="tiny" color="secondary" className="leading-relaxed">
                  {content}
                </Text>
              </div>

              <Button
                variant="neutral"
                appearance="ghost"
                size="sm"
                onClick={onClose}
                isIconOnly
              >
                <PiXLight className="w-4 h-4" />
              </Button>
            </div>
          }
        />
      </motion.div>
    </AnimatePresence>
  );
};
